import script from "./addPatientForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./addPatientForm.vue?vue&type=script&setup=true&lang=ts"

import "./addPatientForm.vue?vue&type=style&index=0&id=7b26a367&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b26a367"]])

export default __exports__